import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import ReactPlaceholder from 'react-placeholder/lib'
import { useParams } from 'react-router-dom'
import Controllers from '../../Api/Controllers'
import parse from 'html-react-parser'
import Helpers from '../../Components/Helpers/Helpers'
import { SurfaceCard, ListPageShell } from '../../Components/Ui'
import { FormCustom, TextArea } from '../../Components/Form/Form'
import { toast } from 'react-toastify'
import { useSelector } from 'react-redux'
import CommentForo from '../Foro/CommentForo'

const avatarFallback = (e) => {
    e.currentTarget.style.display = 'none'
    if (e.currentTarget.nextSibling) e.currentTarget.nextSibling.style.display = 'inline-flex'
}

const btnPrimary = {
    borderRadius: 12,
    fontWeight: 700,
    minHeight: 42,
    padding: '0 18px',
    background: '#201030',
    color: '#fff',
    border: 'none',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    gap: 8
}

const ForoBlog = () => {
    const [foro, setForo] = useState({})
    const [ready, setReady] = useState(false)
    const [readyComments, setReadyComments] = useState(false)
    const [reloadComments, setReloadComments] = useState(false)
    const [loadSubmit, setLoadSubmit] = useState(false)
    const [row, setRow] = useState({
        p_id_foro: '',
        p_description_comment: ''
    })

    const store = useSelector(res => res)
    const [comments, setComments] = useState([])

    const { tokenForo } = useParams()

    useEffect(() => {
        setReady(false)
        Controllers.foro.get_foro_token({
            p_token_foro: tokenForo
        }).then(res => {
            setRow({ ...row, p_id_foro: res.data?.id_foro })
            setForo(res.data)
            setReady(true)
        })
    }, [tokenForo])

    useEffect(() => {
        setReadyComments(true)
        Controllers.comment.get_comment_foro({
            p_token_foro: tokenForo
        }).then(res => {
            setComments(res.data)
            setReloadComments(false)
            setReadyComments(true)
        })
    }, [tokenForo, reloadComments])

    const handleSubmitComment = ({ data }) => {
        setLoadSubmit(true)
        Controllers.comment.comment_foro_insert_update(data).then(res => {
            Helpers.toast.construct({ ...res, toast })
            setRow({ ...row, p_description_comment: '' })
            setReloadComments(true)
            setLoadSubmit(false)
        })
    }

    return <ListPageShell
        eyebrow="Super Papelera — Foro"
        title={foro?.name_foro || 'Tema del Foro'}
        subtitle={foro?.observation_foro ? undefined : 'Conversación del equipo'}
        badge="Discusión"
    >
        <ReactPlaceholder ready={ready} showLoadingAnimation rows={15}>
            {foro?.name_foro ? <>
                <div className="d-flex align-items-center mb-4" style={{ gap: 14, padding: '8px 4px' }}>
                    <div style={{ position: 'relative' }}>
                        <img
                            src={Helpers.config.resourcesUrl({ url: foro.file_photo_foro })}
                            width="56"
                            height="56"
                            alt=""
                            style={{ borderRadius: 999, objectFit: 'cover' }}
                            onError={avatarFallback}
                        />
                        <span className="sp-avatar-fallback" style={{ display: 'none', width: 56, height: 56 }}>
                            <i className="fa fa-user" />
                        </span>
                    </div>
                    <div>
                        <h2 style={{ margin: 0, fontSize: '1.25rem', fontWeight: 800, color: '#201030' }}>{foro.name_foro}</h2>
                        <div style={{ color: '#6B7280', fontSize: '0.9rem', marginTop: 4 }}>
                            {parse(`${foro.observation_foro}`)}
                        </div>
                    </div>
                </div>

                <div className="form-row">
                    <div className="col-12 col-lg-4 mb-3">
                        <SurfaceCard title="Tu comentario">
                            <div className="d-flex align-items-center mb-3" style={{ gap: 10 }}>
                                <img
                                    src={store.session.file_photo_user}
                                    alt=""
                                    width="36"
                                    height="36"
                                    style={{ borderRadius: 999, objectFit: 'cover' }}
                                    onError={avatarFallback}
                                />
                                <span style={{ fontWeight: 600, color: '#201030', fontSize: '0.88rem' }}>
                                    {store.session.full_name || 'Tú'}
                                </span>
                            </div>
                            <FormCustom viewSubmit={false} dataSubmit={row} onSubmit={handleSubmitComment}>
                                <TextArea
                                    text="Escribe tu comentario"
                                    classNameParent="col-12"
                                    rows="5"
                                    required
                                    value={row.p_description_comment}
                                    onChange={e => setRow({ ...row, p_description_comment: e.currentTarget.value })}
                                />
                                <div className="col-12 mt-3">
                                    <button type="submit" style={btnPrimary}>
                                        {loadSubmit
                                            ? <i className="fa fa-circle-notch fa-spin" />
                                            : <><i className="fa fa-paper-plane" />Enviar</>}
                                    </button>
                                </div>
                            </FormCustom>
                        </SurfaceCard>
                    </div>
                    <div className="col-12 col-lg-8">
                        {comments.length === 0 ? (
                            <div className="alert alert-warning mb-0" style={{ borderRadius: 14 }}>
                                <strong>¡Sé el primero!</strong> Deja tu comentario.
                            </div>
                        ) : (
                            <ReactPlaceholder className="mb-2" ready={readyComments} showLoadingAnimation rows={10}>
                                {React.Children.toArray(comments.map(comment => (
                                    <CommentForo comment={comment} onSuccess={_ => setReloadComments(true)} />
                                )))}
                            </ReactPlaceholder>
                        )}
                    </div>
                </div>
            </> : <>
                <div className="alert alert-warning" style={{ borderRadius: 14 }}>
                    <strong>¡Lo sentimos!</strong> No se ha encontrado información.
                </div>
                <Link to={Helpers.config.convertUrl({ url: '/foro' })}>
                    <button type="button" style={btnPrimary}>
                        Volver al foro
                    </button>
                </Link>
            </>}
        </ReactPlaceholder>
    </ListPageShell>
}

export default ForoBlog
